import { useRetailer } from "@faire/deprecated-retailer-visitor-shared/hooks/retailer/useRetailer";
import { useRetailerFinancial } from "@faire/deprecated-retailer-visitor-shared/hooks/retailer/useRetailerFinancial";
import { SignUpTitle } from "@faire/deprecated-retailer-visitor-shared/views/SignUp/_components/SignUpTitle";
import {
  moneyOrZero,
  RoundingStrategy,
  useFormatMoney,
} from "@faire/web/common/money";
import {
  chunkTransformations,
  StrictLocalMsg,
} from "@faire/web/ui/lib/localization";
import React, { useMemo } from "react";

export const Headers: React.FC<{ isRtOwFRejected: boolean }> = ({
  isRtOwFRejected,
}) => {
  const { formatMoney } = useFormatMoney();
  const { retailer } = useRetailer();

  const { currency: displayCurrency } = useRetailerFinancial();

  const { title, subtitle } = useMemo(() => {
    if (isRtOwFRejected) {
      return {
        title: (
          <StrictLocalMsg
            id="S/8UHV"
            defaultMessage="We've got your request for more payment terms"
            description={{
              text: "Header title letting retailer know how their request is being processed",
              img: "https://cdn.faire.com/fastly/4daafc8a69bf2c6bfe4cf89b6d2a79b5e974ea53284d378bc853bdbe3ed57c74.png",
            }}
          />
        ),
        subtitle: (
          <StrictLocalMsg
            id="reh66H"
            defaultMessage="You'll hear from us soon. Until then, get started with your <StrongFormatting>{paymentTermsMoney} in 60-day payment terms.</StrongFormatting>"
            description={{
              text: "Header subtitle telling retailer they'll hear from us soon",
              img: "https://cdn.faire.com/fastly/8f89d32cb112e5c24f80d2c5c7d8b5be09cf8c995a28fad8731aded6168dc0bb.png",
            }}
            values={{
              StrongFormatting: chunkTransformations.strong,
              paymentTermsMoney: formatMoney({
                money: moneyOrZero(retailer?.terms_limit, displayCurrency),
                roundingStrategy: RoundingStrategy.ROUND,
                omitCentsIfZero: true,
              }),
            }}
          />
        ),
      };
    }

    return {
      title: (
        <StrictLocalMsg
          id="vQc2cV"
          defaultMessage="You now have {paymentTermsMoney} in payment terms!"
          description={{
            text: "Header title letting retailer know how much payment terms they have",
            img: "https://cdn.faire.com/fastly/4daafc8a69bf2c6bfe4cf89b6d2a79b5e974ea53284d378bc853bdbe3ed57c74.png",
          }}
          values={{
            paymentTermsMoney: formatMoney({
              money: moneyOrZero(retailer?.terms_limit, displayCurrency),
              roundingStrategy: RoundingStrategy.ROUND,
              omitCentsIfZero: true,
            }),
          }}
        />
      ),
      subtitle: (
        <StrictLocalMsg
          id="nNhv69"
          defaultMessage="Congrats on opening your new store! You can use your higher limit to stock your store with any brand on Faire, helping you manage your cash flow and grow your business."
          description={{
            text: "Header subtitle explaining payment terms to retailer",
            img: "https://cdn.faire.com/fastly/8f89d32cb112e5c24f80d2c5c7d8b5be09cf8c995a28fad8731aded6168dc0bb.png",
          }}
        />
      ),
    };
  }, [isRtOwFRejected, formatMoney, retailer?.terms_limit, displayCurrency]);

  return <SignUpTitle title={title} subtitle={subtitle} />;
};
